import WorkbenchFooter from "./WorkbenchFooter"
import WorkbenchSearch from "./WorkbenchSearch"
import cx from "classnames"
import { navigationItems } from "./FilterTransforms"
import CategoryFilter from "./filters/CategoryFilter"
import RangeFilter from "./filters/RangeFilter"
import ToggleFilters from "./filters/ToggleFilters"
import { Flex } from "@chakra-ui/react"
import ErrorBoundary from "../../shared/components/ErrorBoundary"
import SortByMenu from "./filters/SortByMenu"

const BrowseFiltersContainer = ({ user_role, baseIndexName }) => {
  const isInternalUser = user_role === "internal"

  const sortByItems = (items, fc) =>{
    return items.sort((a, b) => fc.order.indexOf(b.label) - fc.order.indexOf(a.label));
  }
  
  const sortAlph = (items) => {
    return items.sort(function (a, b) {
      if (a.label < b.label) {
        return -1;
      }
      if (a.label > b.label) {
        return 1;
      }
      return 0;
    });
  };

  return (
    <section id="browse-filters-bench" aria-label="Browse filters and search">

      <section
        className={cx(
          "contain",
          "filter-search-nav",
          "search-wrap",
        )}
        aria-label="Search"
      >
        <WorkbenchSearch />
      </section>

      <section
        className={cx(
          "contain",
          "filter-search-nav",
          "filter-wrap",
        )}
        aria-label="Filter"
      >
        <Flex
          width={{smTo2xl: "100%", base: "90%"}}
          justifyContent={{md: "center", sm: "left"}}
          gap={{md: "1rem", sm: "1em", base: "8px"}}
          margin={{base: "18px"}}
          wrap="wrap"
          >
          {Object.keys(navigationItems).map((key, index)=>{
            const currentFilter = navigationItems[key]
            if (!isInternalUser && currentFilter.internal) return null
            if (currentFilter.type === 'list') {
              return ( 
                <ErrorBoundary key={key}>
                  <CategoryFilter 
                    text={currentFilter.label} 
                    isDisabled={false}
                    error={false}
                    id={key}
                    icons={currentFilter.icons}
                    transformItems={
                      currentFilter.order
                        ? (items) => sortByItems(items, currentFilter)
                        : currentFilter.sortAlpha ? (items) => sortAlph(items) 
                        : currentFilter.transform ? currentFilter.transform 
                        : (items)=>items
                    }
                    attribute={currentFilter.attribute}
                    limit={100}
                    operator={currentFilter.operator}
                    allowExclusion={true}
                    internal={!!currentFilter.internal}
                    />
                </ErrorBoundary>)
            } else if (currentFilter.type === "range"){
              return (
                <ErrorBoundary key={key}>
                  <RangeFilter 
                    id={key}
                    attribute={currentFilter.attribute}
                    text={currentFilter.label}
                    min={currentFilter.min}
                    max={currentFilter.max}
                    step={currentFilter.step}
                    formatForTime={!!currentFilter.formatForTime}
                  />
                </ErrorBoundary>
              )
            } else if (currentFilter.type === "toggle"){
              return(
                <ErrorBoundary key={key}>  
                  <ToggleFilters 
                    id={key}
                    label={currentFilter.label}
                    facets={currentFilter.facets}
                    isMulti={currentFilter.isMulti}
                    canNegate={currentFilter.canNegate}
                  />
                </ErrorBoundary>
              )
            }

          })}
          <ErrorBoundary>
            <SortByMenu baseIndexName={baseIndexName} />
          </ErrorBoundary>
        </Flex>

      </section>
      {/* <WorkbenchLegend user_role={user_role} /> */}
      <ErrorBoundary>
        <WorkbenchFooter />
      </ErrorBoundary>
      
    </section>
  )
}

export default BrowseFiltersContainer
